<template>
  <ob-modal2 :show.sync="show" :type="1" :backdrop="false">
    <div style="padding:30px 15px;text-align:center">
      <span v-if="$route.query.from != 'employer-timesheets'" class="close-mark" @click="show = false" style="font-size: 18px;" >&#10006;</span>
      <img style="width:45px;margin-bottom: 16px" :src="`${CDNIMAGESBASEURL}/ess/ESSApp/static/Images/ic_info.svg`" />
      <h4 v-if="$route.query.from != 'employer-timesheets' && selectedReport != undefined"  style="line-height: 24px">
        Do you want to evaluate the tasks performed during
        <b>{{selectedReport.FromDate}}</b> to
        <b>{{selectedReport.ToDate}}</b> ?
      </h4>
      <h4 v-else  style="line-height: 24px">
        Do you want to evaluate the tasks performed during
        <b>{{TimeSheetdateFrom}}</b> to
        <b>{{TimeSheetdateTo}}</b> ?
      </h4>
    </div>
    <div style="padding: 0px 20px 20px 20px;text-align:center;">
      <!-- <ob-button type="secondary" @click="show = false">Close</ob-button> -->
      <ob-button type="secondary" @click="OnSkip()">Skip</ob-button>
      <ob-button @click="OnEvaluate()">Evaluate</ob-button>
    </div>
  </ob-modal2>
</template>
<script>
export default {
  props: ["openEvalutionPopup", "selectedReport","TimeSheetdateFrom","TimeSheetdateTo","TimesheetType"], 
  data() {
    return {
      show: false
    };
  },
  created() {
    this.show = this.openEvalutionPopup;
  },
  computed: {
    TimeSheetId() {
      return this.selectedReport.Id;
    }
  },
  watch: {
    openEvalutionPopup(val) {
      this.show = val;
    },
    show(val) {
      this.$emit("update:openEvalutionPopup", val);
    }
  },
  methods: {
    OnSkip() {
      if(this.$route.query.from == 'employer-timesheets'){ 
        this.show = false;
        this.$message({
            type: "success",
            // message: "Timesheet approved successfully"
            message:this.TimesheetType== "TimesheetAndExpenses" ? "Timesheet(s) and Expense(s) approved successfully" : "Timesheet(s) approved successfully",
            });
          if(this.$route.query.listView)
          {
              this.$router.push({'path': '/timesheets-list', query: { listView: "true" }})
          }
          else
          {
            this.$router.push({ name: "employer-timesheets" });
          }
      }
      else{
      this.$parent.$parent.OnSkipEvaluate();
      this.show = false;
      }
    },
    OnEvaluate() {
      if(this.$route.query.from == 'employer-timesheets'){
          this.$parent.$parent.$parent.OpenvaluationReport();
      }
      else{
        this.$parent.$parent.onEvalutionButtonClick();
      }
    }
  }
};
</script>
<style lang="scss" scoped>

.close-mark{
      float: right;
      font-size: 15px;
      padding: 0px 5px;
      border-radius: 20%;
      cursor: pointer;
    }
    .close-mark:hover{
      background:  #c2c2c2c2;
      padding: 0px 5px;
      border-radius: 20%;
      text-decoration: none !important;
    }
</style>



// WEBPACK FOOTER //
// src/components/ESSProfile/Timesheets/Calender/ApprovalFlow/EvaluationPopup.vue